import { PRIMARY, makeThemeColor } from '@tornado-rdk/theme';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../utils/style';
import { middle } from '../../utils/sizes';
import { UNFOCUSED_ITEM_ALPHA } from '../restrictedInput.style';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  border: makeThemeColor(PRIMARY),
};

export const BORDER_WIDTH = {
  [HD]: 2,
  [FULL_HD]: 4,
};

export const PASSWORD_ITEM_WIDTH = {
  [HD]: 74,
  [FULL_HD]: 99,
};

export const PASSWORD_ITEM_HEIGHT = {
  [HD]: 158,
  [FULL_HD]: 195,
};

export const PASSWORD_ITEM_OFFSET = {
  [HD]: 6,
  [FULL_HD]: 8,
};

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => ({
  w: PASSWORD_ITEM_WIDTH[screenSize],
  h: PASSWORD_ITEM_HEIGHT[screenSize],
  flexItem: {
    marginRight: PASSWORD_ITEM_OFFSET[screenSize],
    marginLeft: PASSWORD_ITEM_OFFSET[screenSize],
  },
  Border: {
    alpha: UNFOCUSED_ITEM_ALPHA,
    borderWidth: BORDER_WIDTH[screenSize],
    colorBorder: colors.border[colorMode],
    w: PASSWORD_ITEM_WIDTH[screenSize],
    h: PASSWORD_ITEM_HEIGHT[screenSize],
  },
  Number: {
    mountX: 0.5,
    mountY: 0.5,
    x: middle,
    y: middle,
    text: {
      ...getFont(FONT.TOKYO_4, screenSize),
      verticalAlign: 'middle',
    },
  },
});
